module.exports = __webpack_public_path__ + "img/12.46514732.jpg";